export default __webpack_public_path__ + "0840399cde6d33c719733624dc8fed1c.png";